import moment from 'moment'
import accounting from 'accounting'

function _formatDateTime (value) {
  return (value == null)
  ? ''
  : moment(new Date(value)).format('DD-MM-YYYY  HH:mm')
}
export default {
  formatBoolean (value) { return value ? 'Yes' : 'No' },
  formatDate (value) {
    return (value == null)
    ? ''
    : moment(new Date(value)).format('DD-MM-YYYY')
  },
  formatDateTime (value) { return _formatDateTime(value) },
  formatTimeStamp (value) { return _formatDateTime(value) },
  formatMoney (value) {
    if (value === null) return ''
    else {
      return accounting.formatMoney(value, '€', 2)
    }
  }
}



// WEBPACK FOOTER //
// ./src/formatting/index.js